<template>
    <img src="../../../../assets/image/live/goods.png" class="goods" @click="showgoods"/>
</template>

<script>
export default {
  props: {
  },
  data () {
    return {}
  },
  methods: {
    showgoods () {
      this.$emit('showgoods')
    }
  },
  computed: {}
}
</script>
<style type="scss" scoped>
    .goods {
        width: 1.35rem;
        height: 1.35rem;
    }
</style>
